import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "timeline-item skeleton"
}
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "head" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = { class: "heading" }
const _hoisted_7 = {
  key: 0,
  class: "description"
}
const _hoisted_8 = {
  key: 1,
  class: "updated-by"
}
const _hoisted_9 = {
  key: 0,
  class: "sub-heading"
}
const _hoisted_10 = { class: "left" }
const _hoisted_11 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_status_indicator = _resolveComponent("status-indicator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_message_block = _resolveComponent("message-block")!

  return (_ctx.skeleton)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_skeleton, { height: "15px" }),
          _createVNode(_component_q_skeleton, { height: "15px" })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "orb",
            style: _normalizeStyle(_ctx.orbStyle)
          }, null, 4),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "line dashed" }, null, -1))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["timeline-item", _ctx.type])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _renderSlot(_ctx.$slots, "head", { heading: _ctx.heading }, () => [
                _createTextVNode(_toDisplayString(_ctx.heading), 1)
              ], true)
            ]),
            (_ctx.description)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "description", { description: _ctx.description }, () => [
                    _createTextVNode(_toDisplayString(_ctx.description), 1)
                  ], true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.updatedBy !== 'not_set')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _renderSlot(_ctx.$slots, "updated_by", { updated_by: _ctx.updatedBy }, () => [
                    _createTextVNode(_toDisplayString(_ctx.updatedBy), 1)
                  ], true)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.subHeading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _renderSlot(_ctx.$slots, "sub_heading", { sub_heading: _ctx.subHeading }, () => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.subHeading), 1)
                ], true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_status_indicator, {
            type: _ctx.type,
            style: {"margin":"7px 0px"}
          }, null, 8, ["type"]),
          _createElementVNode("div", {
            class: _normalizeClass(["line", { dashed: ['error', 'pending'].includes(_ctx.type) && !_ctx.loading }])
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.metaData)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                ripple: false,
                color: "primary",
                unelevated: "",
                padding: "3px 0px",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDetails = !_ctx.showDetails)),
                flat: ""
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Show details")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showDetails)
          ? _renderSlot(_ctx.$slots, "default", {
              key: 0,
              metadata: _ctx.metaData
            }, undefined, true)
          : _createCommentVNode("", true),
        (_ctx.type === 'error' && _ctx.message)
          ? _renderSlot(_ctx.$slots, "error", { key: 1 }, () => [
              _createVNode(_component_message_block, {
                type: "error",
                message: _ctx.message
              }, null, 8, ["message"])
            ], true)
          : _createCommentVNode("", true),
        (_ctx.type === 'warning')
          ? _renderSlot(_ctx.$slots, "warning", { key: 2 }, () => [
              _createVNode(_component_message_block, {
                type: "warning",
                message: _ctx.message
              }, null, 8, ["message"])
            ], true)
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? _renderSlot(_ctx.$slots, "loading", { key: 3 }, () => [
              _createVNode(_component_message_block, {
                message: _ctx.message || 'Retrieving status...',
                style: { textAlign: 'center', fontWeight: 700 }
              }, null, 8, ["message"])
            ], true)
          : _createCommentVNode("", true)
      ], 2))
}